<template>
  <el-drawer class="drawer fs-credit-drawer fs-bg-wh fs-drawer-h" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open"
    direction="btt" v-if="PreOrderDetail">
    <el-row class="fs-site">
      <el-col class="fs-entry-header text-center">
        <h2>{{ $t('drawer.preorder.selecttime') }}</h2>
      </el-col>
      <el-col class="fs-credit-content mb-2">
        <smooth-picker ref="smoothPicker" :data="data" :change="dataChange" />
      </el-col>
      <!-- <el-col class="fs-credit-footer"> -->
        <el-col>
        <!-- CASE 1 Phase 3.0 -->
        <el-row v-if="PreOrderDetail.deliveryTime.isOpen && PreOrderDetail.preOrderSetting.preorderFlag && PreOrderDetail.orderNowSetting.orderNowFlag">
          <el-col :span="12" class="pr-2">
            <fullButton :bgcolor="'fs-btn-border'" :handleClick="()=>{ sendPreorderTime('now') }" :btn_text="$t('drawer.preorder.now')" />
          </el-col>
          <el-col :span="12">
            <fullButton :handleClick="()=>{ sendPreorderTime('preorder') }" :btn_text="$t('dialog.preorder.btnpreorder')" />
          </el-col>
        </el-row>
        <!-- CASE ETC. Phase 3.0 -->
        <el-row v-else>
          <el-col>
            <fullButton :handleClick="()=>{ sendPreorderTime('preorder') }" :btn_text="$t('dialog.preorder.btnpreorder')" />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-drawer>
</template>
<script>
import fullButton from '@/components/element/fullButton'
import Mixins from '@/utils/mixins'
  export default {
    name: 'DrawerPreorderTime',
    components: {
      fullButton
    },
    props: ['datetime'],
    mixins: [Mixins],
    data () {
      return {
        is_open: true,
        data: [],
        TmpSelectPreorderDate: 0,
        SelectPreorderTime: [],
        StrDate: null,
        StrTime: null,
        IndexDate: null,
        IndexTime: null
      }
    },
    methods: {
      dataChange () {
        // console.log('dev1')
        const List = this.$refs.smoothPicker.getCurrentIndexList()
        this.IndexDate = List[0] // date
        this.IndexTime = List[1] // time
        this.StrDate = this.data[0].list[this.IndexDate]
        this.StrTime = this.data[1].list[this.IndexTime]
        // Recheck Time When Select New Date
        if (this.TmpSelectPreorderDate != this.IndexDate) {
          let currentIndex = (this.TmpSelectPreorderDate == 0) ? this.IndexTime : 0
          let list = this.PreOrderDetail.preOrderDate[this.IndexDate].timeList
          // Scroll Date By Index
          this.$refs.smoothPicker.setGroupData(1, Object.assign({}, this.data[1], { currentIndex, list }))
          // Set New Time When Select New Date
          this.StrDate = this.data[0].list[this.IndexDate]
          this.StrTime = this.data[1].list[this.IndexTime]
        }
        // Set Tmp Date When Select New Date
        this.TmpSelectPreorderDate = this.IndexDate

        // Send Time PreOrder
        this.SelectPreorderTime = [this.showPreOrderDateTime(this.StrDate, this.StrTime), this.getFormatPreOrderDateTime(this.StrDate, this.StrTime), this.IndexDate, this.IndexTime]
      },
      setDataToSmoothPicker (date, time) {
        this.data = [{
          currentIndex: date[0],
          flex: 6,
          list: date[1],
          textAlign: 'center',
          className: 'row-group'
        },
        {
          currentIndex: time[0],
          flex: 6,
          list: time[1],
          textAlign: 'center',
          className: 'row-group'
        }]
      },
      sendPreorderTime (type) {
        if (type == 'now') {
          this.$emit('toogle_preorder', [])
          this.$store.dispatch('setCachePreorderTime', [])
        } else {
          // Cache Preorder Time To State
          this.is_open = false
          this.$store.dispatch('setCachePreorderTime', this.SelectPreorderTime)
          this.$emit('toggle_preorder', this.SelectPreorderTime)
        }
      }
    },
    computed: {
      PreOrderDetail () {
        let preorder = this.$store.getters.PreOrderDetail
        let preOrderDate = preorder.preOrderDate
        let arrPreOrderDate = []
        let arrPreOrderTime = []

        preOrderDate.forEach( (element, index) => {
          let splitDate = element.date.split('-')
          let strdate = (this.isTodayFormat(element.date)) ? 'Today ' + splitDate[2] + ' ' + this.filter_short_month_en(element.date) + ' ' + splitDate[0] : this.filter_short_day_en(element.date) + ' ' + splitDate[2] + ' ' + this.filter_short_month_en(element.date) + ' ' + splitDate[0]
          arrPreOrderDate.push(strdate)
          // arrPreOrderDate.push(element.date)
          arrPreOrderTime.push(element.timeList)
          if (index == 0) {
            this.StrDate = this.filter_short_day_en(element.date) + ' ' + splitDate[2] + ' ' + this.filter_short_month_en(element.date) + ' ' + splitDate[0]
            // this.StrDate = element.date
            this.StrTime = element.timeList[0]

            if (this.CachePreorderTime.length > 0) {
              // Set Cache Preorder Time
              this.SelectPreorderTime = this.CachePreorderTime
            } else {
              // Set Default Preorder Time
              this.SelectPreorderTime = [
                // this.showPreOrderDateTime(element.date, element.timeList[0]),
                // this.getFormatPreOrderDateTime(element.date, element.timeList[0]),
                this.showPreOrderDateTime(this.filter_short_day_en(element.date) + ' ' + splitDate[2] + ' ' + this.filter_short_month_en(element.date) + ' ' + splitDate[0], element.timeList[0]),
                this.getFormatPreOrderDateTime(this.filter_short_day_en(element.date) + ' ' + splitDate[2] + ' ' + this.filter_short_month_en(element.date) + ' ' + splitDate[0], element.timeList[0]),
                0,
                0
              ]

              // When Change Preorder Time --> CASE 2,3,4 Phase 3.0 --> Reset Preorder Time First Array preOrderDate
              if (preorder !== null && preorder.deliveryTime.isOpen && !preorder.orderNowSetting.orderNowFlag && preorder.preOrderSetting.preorderFlag ||
                  preorder !== null && !preorder.deliveryTime.isOpen && preorder.orderNowSetting.orderNowFlag && preorder.preOrderSetting.preorderFlag ||
                  preorder !== null && !preorder.deliveryTime.isOpen && !preorder.orderNowSetting.orderNowFlag && preorder.preOrderSetting.preorderFlag) {
                    // Set Cache Preorder Time Case 2,3,4
                    this.$store.dispatch('setCachePreorderTime', this.SelectPreorderTime)
              }

            }
          }
        })

        if (this.CachePreorderTime.length > 0) {
          this.setDataToSmoothPicker([this.CachePreorderTime[2], arrPreOrderDate], [this.CachePreorderTime[3], arrPreOrderTime[this.CachePreorderTime[2]]])
        } else {
          this.setDataToSmoothPicker([0, arrPreOrderDate], [0, arrPreOrderTime[0]])
        }

        return preorder
      },
      CachePreorderTime () {
        return this.$store.getters.CachePreorderTime
      }
    },
    watch: {
      CachePreorderTime () {},
      is_open () {
        this.$emit('toogle_preorder', this.CachePreorderTime)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/preorder/DrawerPreorderTime.vue